// 👉 Redirects
export const redirects = [
    // ℹ️ We are redirecting to different pages based on role.
    // NOTE: Role is just for UI purposes. ACL is based on abilities.
    {
        path: '/',
        name: 'index',
        redirect: to => {
            // TODO: Get type from backend
            const userData = useCookie('userData')
            const userRole = userData.value?.role
           
            if (userRole == 'admin' || userRole == 'other') {// userRole === 'admin' || userRole === 'other'
                
                return { name: 'dashboard' }
            } else {                
                return {name: 'login', query: to.query}
            }

        },
    },

]
